import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALINSTITUTIONCONTRACT_LOAD_BY_TRIAL_INSTITUTION_ID,
    ACTION_TRIALINSTITUTIONCONTRACT_LOAD_BY_ID,

    ACTION_TRIALINSTITUTIONCONTRACT_SAVE,

    ACTION_TRIALINSTITUTIONCONTRACT_CREATE,

    ACTION_TRIALINSTITUTIONCONTRACT_DELETE,

    ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE,

    ITrialInstitutionContractLoadByTrialInstitutionIdAction,
    ITrialInstitutionContractLoadByIdAction,
    ITrialInstitutionContractLoadFailureAction,
    ITrialInstitutionContractLoadSuccessAction,

    ITrialInstitutionContractSaveAction,
    ITrialInstitutionContractSaveSuccessAction,
    ITrialInstitutionContractSaveFailureAction,

    ITrialInstitutionContractCreateAction,
    ITrialInstitutionContractCreateSuccessAction,
    ITrialInstitutionContractCreateFailureAction,

    ITrialInstitutionContractDeleteAction,
    ITrialInstitutionContractDeleteSuccessAction,
    ITrialInstitutionContractDeleteFailureAction,

    ITrialInstitutionContractValidateAction,
    ITrialInstitutionContractValidateSuccessAction,
    ITrialInstitutionContractValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    DeleteSuccess,
    DeleteFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialInstitutionContract";
import { trialInstitutionContractApi } from "../services/trialInstitutionContract";

export const
    getTrialInstitutionContractByTrialInstitutionIdEpic = (action$): Observable<ITrialInstitutionContractLoadSuccessAction | ITrialInstitutionContractLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONCONTRACT_LOAD_BY_TRIAL_INSTITUTION_ID)
            .mergeMap((action: ITrialInstitutionContractLoadByTrialInstitutionIdAction) => {
                return trialInstitutionContractApi
                    .getTrialInstitutionContractByTrialInstitutionId(action.trialInstitutionId)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionContract, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialInstitutionContractByIdEpic = (action$): Observable<ITrialInstitutionContractLoadSuccessAction | ITrialInstitutionContractLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONCONTRACT_LOAD_BY_ID)
            .mergeMap((action: ITrialInstitutionContractLoadByIdAction) => {
                return trialInstitutionContractApi
                    .getTrialInstitutionContractById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionContract, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialInstitutionContractEpic = (action$): Observable<ITrialInstitutionContractSaveSuccessAction | ITrialInstitutionContractSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONCONTRACT_SAVE)
            .mergeMap((action: ITrialInstitutionContractSaveAction) => {
                return trialInstitutionContractApi
                    .setTrialInstitutionContract(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialInstitutionContract, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialInstitutionContractEpic = (action$): Observable<ITrialInstitutionContractCreateSuccessAction | ITrialInstitutionContractCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONCONTRACT_CREATE)
            .mergeMap((action: ITrialInstitutionContractCreateAction) => {
                return trialInstitutionContractApi
                    .createTrialInstitutionContract(action.trialInstitutionId)
                    .map(response =>
                        CreateSuccess(
                            response.trialInstitutionContract,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialInstitutionContractEpic = (action$): Observable<ITrialInstitutionContractValidateSuccessAction | ITrialInstitutionContractValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONCONTRACT_VALIDATE)
            .mergeMap((action: ITrialInstitutionContractValidateAction) => {
                return trialInstitutionContractApi
                    .validateTrialInstitutionContract(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialInstitutionContract, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    },
    deleteTrialInstitutionContractEpic = (action$): Observable<ITrialInstitutionContractDeleteSuccessAction | ITrialInstitutionContractDeleteFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONCONTRACT_DELETE)
            .mergeMap((action: ITrialInstitutionContractDeleteAction) => {
                return trialInstitutionContractApi
                    .deleteTrialInstitutionContract(action.id)
                    .map(_response =>
                        DeleteSuccess()
                    )
                    .catch(error =>
                        Observable.of(DeleteFailure(error.responseStatus))
                    )
            });
    }